if (!customElements.get('add-on-products')) {
  customElements.define(
    'add-on-products',
    class AddOnProducts extends HTMLElement {
      planChangeUnsubscriber = undefined;
      subscribed = true;
      isCartPage = false;

      // This was originally on main-product, then separated out to this file
      // Now it is to be used on the PDP and also on the cart page
      // On the cart page it should behave the following way:
      // 1. add product
      // 2. disappear after add
      // 3. reappear if removed
      // Easiest way is to add + refresh
      // Therefore create a function to add, refresh on success

      connectedCallback() {
        if (window.location.pathname === '/cart') {
          this.isCartPage = true;
        } else {
          this.initAddOns();
          this.updatePrices();

          this.planChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.planChange, (e) => {
            let lastValue = this.subscribed;
            this.subscribed = e.isSubscribed;
            if (lastValue !== this.subscribed) {
              this.updatePrices();
            }
          });

          const debouncedOnChange = debounce(async (event) => {
            if (window.Shopify?.pageType === 'product' && event.source === 'product-form') {
              if (event.cartData?.handle === window.location.pathname.split('/')[2]) {
                const addOns = this.getAddOns();

                if (addOns.length > 0) {
                  await this.addProductAddOnsToCart(addOns);
                  this.refreshCartDrawer();
                  this.updateCartCount();
                }
              }
            }
          }, ON_CHANGE_DEBOUNCE_TIMER);

          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            debouncedOnChange(event);
          });
        }
      }

      disconnectedCallback() {
        if (window.location.pathname === '/cart') {
        } else {
          if (this.planChangeUnsubscriber) {
            this.planChangeUnsubscriber = undefined;
          }
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }
        }
      }

      getAddOns() {
        return Array.from(
          document.querySelector('product-info add-on-products .customize-add-ons__added').childNodes,
        ).map((v) => {
          return { id: Number(v.dataset.variantId), sellingPlan: Number(v.dataset.sellingPlanId) };
        });
      }

      updatePrices() {
        if (this.subscribed) {
          document.querySelectorAll('product-info add-on-products li').forEach((item) => {
            item.querySelector('.add-on-btn .price-item.price-item--sale.price-item--last').innerHTML =
              `+$${Math.round(Number(item.dataset.planPrice) / 100)}`;
          });
        } else {
          document.querySelectorAll('product-info add-on-products li').forEach((item) => {
            item.querySelector('.add-on-btn .price-item.price-item--sale.price-item--last').innerHTML =
              `+$${Math.round(Number(item.dataset.otpPrice) / 100)}`;
          });
        }
      }

      async addProductAddOnsToCart(addOns) {
        const items = addOns.map((v) => ({
          id: v.id,
          quantity: 1,
          ...(v.sellingPlan && this.subscribed && { selling_plan: v.sellingPlan }),
        }));
        const body = JSON.stringify({ items: items });
        const results = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } }).then((response) =>
          response.json(),
        );
        return results;
      }

      async refreshCartDrawer() {
        return await fetch('/?section_id=cart-drawer')
          .then((data) => {
            return data.text();
          })
          .then((res) => {
            const cartDrawerContainer = document.querySelector('cart-drawer');
            const oldCartDrawerElement = document.querySelector('.cart-drawer');
            const fragment = document.createDocumentFragment();
            const newCartDrawerElement = document.createElement('div');

            newCartDrawerElement.insertAdjacentHTML('afterbegin', res);
            fragment.appendChild(newCartDrawerElement.querySelector('.cart-drawer'));
            cartDrawerContainer.removeChild(oldCartDrawerElement);
            cartDrawerContainer.appendChild(fragment);
            console.info('Cart drawer refreshed');

            // TODO: update quantity in cart bubble
          })
          .catch((e) => {
            console.error(e);
          });
      }

      // TODO: cleanup/refactor for readability
      initAddOns() {
        document.querySelectorAll('.customize-add-ons li').forEach((addOnProduct) => {
          addOnProduct
            .querySelector('.add-on-btn button[name="add"]')
            .addEventListener('click', this.clickHandler.bind(addOnProduct));
        });
      }

      clickHandler(e) {
        const available_list = document.querySelector('ul.customize-add-ons');
        const added_list = document.querySelector('ul.customize-add-ons__added');

        const liItem = e.target.closest('li.grid__item');
        const available = e.target.closest('ul.customize-add-ons');
        const unavailable = e.target.closest('ul.customize-add-ons__added');
        const liTitle = liItem.querySelector('.card > .card__content .card__information');
        const addOnProductTitle = liTitle.querySelector('a').textContent;

        if (available) {
          added_list.insertAdjacentElement('afterbegin', liItem);
          added_list.classList.remove('empty');
          if (!available_list.childElementCount) {
            available_list.classList.add('empty');
          }

          if (!liTitle.querySelector('label')) {
            liTitle.insertAdjacentHTML(
              'beforeend',
              `<label class="form__label"><strong>${addOnProductTitle}</strong></label>`,
            );
          }

          liItem.querySelector('.add-on-btn > button').innerHTML =
            '<span class="icon-remove">X</span> <span>REMOVE</span>';
        } else if (unavailable) {
          available_list.insertAdjacentElement('afterbegin', liItem);
          available_list.classList.remove('empty');
          if (!added_list.childElementCount) {
            added_list.classList.add('empty');
          }
          liItem.querySelector('.add-on-btn > button').innerHTML = '+ ADD';
        }
      }
    },
  );
}
